import type { Appearance } from "@clerk/types";

export const clerkTheme: Appearance = {
  elements: {
    formButtonPrimary:
      "bg-brand-primary hover:bg-brand-primary/90 text-white font-semibold",
    card: "shadow-none border-0 bg-brand-background",
    rootBox: "mx-auto",
    headerTitle: "text-white",
    headerSubtitle: "text-gray-400",
    socialButtonsBlockButton: "border-gray-700 hover:bg-gray-800 text-white",
    socialButtonsBlockButtonText: "text-white",
    formFieldInput:
      "border-gray-700 bg-gray-900 text-white focus:border-brand-primary focus:ring-brand-primary",
    formFieldLabel: "text-gray-300",
    footerActionLink: "text-brand-primary hover:text-brand-primary/80 font-medium",
    identityPreviewEditButton: "text-brand-primary",
    formResendCodeLink: "text-brand-primary",
    otpCodeFieldInput: "border-gray-700 bg-gray-900 text-white focus:border-brand-primary",
    otpCodeFieldInputs: "gap-2",
  },
  variables: {
    colorPrimary: "#fb7185",
    colorText: "#ffffff",
    colorTextSecondary: "#9ca3af",
    colorBackground: "#050816",
    colorInputBackground: "#111827",
    colorInputText: "#ffffff",
    borderRadius: "0.75rem",
    fontFamily: "Inter, system-ui, sans-serif",
  },
};

